<template>
  <div id="app" v-reset-page>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { getUrlParams, sourceObj, version } from './utils'
import { _functionConfig } from './utils/const'
import { loginLog } from '@/api/api_home'

export default {
  name: 'App',
  data() {
    return {
      isReset: true,
    }
  },
  components: {},
  beforeCreate() {
    let s = getUrlParams('s') || 'H5'
    if (localStorage.getItem('s') != s) {
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
    }
  },
  created() {
    if (version().ios) {
      window.initUrl = window.location.href.split('#')[0]
    }
    // 解决关闭页面重新进入问题，重新获取数据存入vuex
    let bossUserId = getUrlParams('userId') // 解决从第三方进入后，token未更新导致token失效的问题
    if (!bossUserId && localStorage.getItem('token') && !sessionStorage.getItem('userInfo')) {
      try {
        // 页面刷新获取userInfo
        this.$store.dispatch('getMyPageInfo', { router: this.$router })
      } catch (e) {
        console.log(e)
      }
    }
    // 页面加载前读取sessionStorage里的状态信息
    if (sessionStorage.getItem('userInfo')) {
      try {
        this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('userInfo'))))
      } catch (e) {
        console.log(e)
      }
    }
    // 监听浏览器关闭和刷新事件：beforeunload不兼容ios；pagehide没有问题
    window.addEventListener('pagehide', () => {
      // 在页面刷新前将vuex里的信息保存到sessionStorage里
      sessionStorage.setItem('userInfo', JSON.stringify(this.$store.state))
    })
    // ios页面输入框失焦要页面重置到顶部
    if (version().ios) {
      // 判断是否是ios端
      document.body.addEventListener('focusin', function() {
        //软键盘弹出的事件处理
        this.isReset = false
      })
      document.body.addEventListener('focusout', this.scrollTO())
    }
    document.body.removeEventListener('focusout', this.scrollTO())
    // eslint-disable-next-line
    sensors.registerPage({
      is_vip: Number(this.vipLevel) ? true : false,
    })
    let s = localStorage.getItem('s') || getUrlParams('s')
    // eslint-disable-next-line
    sensors.registerPage({
      platform_type: sourceObj[s ? s : 'H5'],
    })
    // eslint-disable-next-line
    sensors.quick('autoTrack')
    // 存储页面功能配置
    let baseFuncionConfig = {
        isGuideVip: true,
        showAssitantIcon: true,
        isShareConfig: true,
        isOpenVipFun: true
      }
    _functionConfig[s] =  _functionConfig[s] || baseFuncionConfig
    Object.assign(baseFuncionConfig, _functionConfig[s])
    sessionStorage.setItem('functionConfig', JSON.stringify(baseFuncionConfig))
  },
  mounted() {
    // 微信分享卡片信息
    // if(version().weixin){
    //   this.defalutShare()
    // }
    let s = localStorage.getItem('s') 
    if (s === 'PA' && !sessionStorage.getItem('loginSessionLog')) {
      sessionStorage.setItem('loginSessionLog', true)
      this.submitLoginLog()
      // eslint-disable-next-line
      sensors.login(localStorage.getItem('userId'))
    }
  },
  computed: {
    vipLevel() {
      return this.$store.state.vipLevel
    },
  },
  watch: {
    vipLevel: function(old, newd) {
      // eslint-disable-next-line
      sensors.registerPage({
        is_vip: Number(newd) ? true : false,
      })
    },
  },
  methods: {
    scrollTO() {
      //软键盘收起的事件处理
      this.isReset = true
      setTimeout(function() {
        //当焦点在弹出层的输入框之间切换时先不归位
        if (this.isReset) {
          window.scrollTo(0, 0) //失焦后强制让页面归位
        }
      }, 300)
    },
    // async defalutShare() {
    //   let params = {
    //     type: 1
    //   }
    //   let res = await cardShareInfo(params)
    //   if(res && res.ok){
    //     let data = res.data
    //     if(this.s !== 'BS'){
    //       this.WechatShare({
    //         title: data.title,
    //         desc: data.desc,
    //         imgUrl: data.imgUrl,
    //         link: data.linkUrl
    //       },window.initUrl ? window.initUrl: '')
    //     }
    //   }
    // },
    async submitLoginLog() {
      let params = {
        loginChannel: localStorage.getItem('loginChannel'),
      }
      await loginLog(params)
    }
  }
}
</script>

<style>
#app {
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  color: #333;
}
</style>
